import React from "react";
import { StyleSheet, View } from "react-native";
import Gap from "../Gap";
import Icon from "../Icon";
import RText from "../RText";
import RButton from "./RButton";

export type LiveButtonProps = {
  onPress?: Function;
};

export default function LiveButton({
  onPress = () => console.log("pressed."),
}: LiveButtonProps) {
  return (
    <RButton
      onPress={onPress}
      style={styles.buttonRound}
      customTextStyle={{ display: "none" }}
      dataSetButton={{ id: "live-button" }}
      dataSetButtonText={{ id: "live-button-text" }}
    >
      <View
        accessibilityLabel="live-button"
        style={styles.livePlayContentContainer}
      >
        <RText
          family="secondary"
          weight="bold"
          size="md"
          color="white"
          style={styles.liveText}
        >
          Live
        </RText>
        <Gap size="xxsmall" />
        <Icon name="play" size="medium" />
      </View>
    </RButton>
  );
}

const styles = StyleSheet.create({
  buttonRound: {
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 6,
    paddingHorizontal: 8,
    borderRadius: 36,
    borderWidth: 1.5,
  },
  livePlayContentContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  liveText: {
    textTransform: "uppercase",
    paddingRight: 0,
    paddingLeft: 8,
  },
});
